<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5.primary
        v-row(no-gutters)
          v-col
            p.mb-0.title.white--text
              span Welcome to Angsana Digital Mall
  
      v-card-text.pa-0
        v-form.pa-3(ref="form")
          v-text-field.mt-4(color="primary" v-model="lotNo" type="text" label="Lot no" outlined required :rules="rules.lotNo" hint="Please refer to your tenant aggreement" :persistent-hint="true")
      v-divider
      v-card-actions
        v-spacer
        v-btn.mr-2(color='accent' depressed height=32 @click='createTennant' :loading="loading")
          | Save

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'InvitedList',
  props: ['open', 'company'],
  data: () => ({
    lotNo: '',
    loading: false,
    rules: {
      lotNo: [
        v => !!v || 'Lot no is required'
      ]
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    createTennant () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      let params = {
        company: this.company.id,
        name: `${this.company.slug} - mall`,
        email_enabled: false,
        email_required: false,
        layout: 'list',
        extra_fields: [],
        type: 'whatsapp',
        hidden: true,
        status: 'published'
      }
      this.$axios.post('/forms/', params)
        .then((response) => {
          let branchId = 1
          const datas = this.company.sponsor.slug.split('-')
          if (datas.length > 2) {
            branchId = datas[2]
          }
          params = {
            company: this.company.id,
            branch: branchId,
            name: this.company.name,
            description: '',
            form: response.data.id,
            extra_data: { lot_no: this.lotNo }
          }
          this.$axios.post('/malls/1/branches/1/tenants/', params)
            .then(() => {
              location.href = `/admin/yezza-mall`
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              this.loading = false
            })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.hide-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<i18n>
{
  "en": {
    "invited_list": "Invited List",
    "first_name": {
      "label": "First Name",
      "placeholder": "Write first name here"
    },
    "last_name": {
      "label": "Last Name",
      "placeholder": "Write last name here"
    },
    "staff_id": {
      "label": "Staff ID",
      "placeholder": "Write staff ID (if any)"
    },
    "email": {
      "label": "Email",
      "placeholder": "Write email here"
    },
    "phone": {
      "label": "Mobile Phone",
      "placeholder": "Phone Number"
    },
    "add": "Add",
    "save": "Save"
  }
}
</i18n>
